import { render, staticRenderFns } from "./IntegrationRequestResultModal.vue?vue&type=template&id=2796ada2&scoped=true"
import script from "./IntegrationRequestResultModal.vue?vue&type=script&lang=ts"
export * from "./IntegrationRequestResultModal.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationRequestResultModal.vue?vue&type=style&index=0&id=2796ada2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796ada2",
  null
  
)

export default component.exports